module.exports = __webpack_public_path__ + "static/media/comments.cfb54913.svg";